module.exports = __webpack_public_path__ + "media/cases-brand-tommee-lazyload-91.fbf50e9f.mp4";